import { jsx as r } from "react/jsx-runtime";
import t from "../base-button.mjs";
const n = (o) => /* @__PURE__ */ r(
  t,
  {
    color: "text-text-primary/50",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-brand-primary",
    ...o
  }
);
export {
  n as LightButton
};
